var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCertification(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.75 4v11A1.76 1.76 0 0 1 20 16.75h-6a.75.75 0 0 1 0-1.5h6a.25.25 0 0 0 .25-.25V4a.25.25 0 0 0-.25-.25H4a.25.25 0 0 0-.25.25v11a.25.25 0 0 0 .25.25h6a.75.75 0 0 1 0 1.5H4A1.76 1.76 0 0 1 2.25 15V4A1.76 1.76 0 0 1 4 2.25h16A1.76 1.76 0 0 1 21.75 4zM6.25 9a.76.76 0 0 0 .75.75h10a.75.75 0 0 0 0-1.5H7a.76.76 0 0 0-.75.75zM15 6.75a.75.75 0 0 0 0-1.5H9a.75.75 0 0 0 0 1.5z",
    fill: "#112d55",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e9941",
    d: "M15.25 14.5a3.25 3.25 0 1 0-6 1.71V21a.75.75 0 0 0 1.16.63l1.59-1 1.59 1a.78.78 0 0 0 .41.12.77.77 0 0 0 .36-.09.76.76 0 0 0 .39-.66v-4.79a3.23 3.23 0 0 0 .5-1.71zM12 12.75a1.75 1.75 0 1 1-1.75 1.75A1.76 1.76 0 0 1 12 12.75zm.41 6.33a.76.76 0 0 0-.82 0l-.84.55V17.5a3.25 3.25 0 0 0 2.5 0v2.13z",
    opacity: 1,
    "data-original": "#f25220",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertification);
export default __webpack_public_path__ + "static/media/certification.674fc7a7c4064c0ac742ef117ee2cc4d.svg";
export { ForwardRef as ReactComponent };